export default __webpack_public_path__ + "static/screeny-85-gpz-s-2-a99d67590ed6b1f3893d53f5452371fa.jpg";